module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-company/05-cf0e5dedc6eaf8ea091dcd3a2d594412.png";